import PaymentManager from '../../services/PaymentManager'
import { savePaymentConfigApi } from '../../api/paymentConfig.api'
import { analytics } from '../../services/Analytics/Analytics'

export default async function syncPayment(api, remotePaymentConfig, source) {
  const localPaymentInfo = PaymentManager.getPaymentInfo()
  if (remotePaymentConfig && !localPaymentInfo?.stripeCustomerId) {
    analytics.track('Restored payment', { Source: source })
    await PaymentManager.loadStripeCustomerFromAccount(remotePaymentConfig)
  }

  if (PaymentManager.shouldLoadCardFromStripe()) {
    await PaymentManager.loadCardFromStripe()
  }

  if (
    api &&
    localPaymentInfo?.stripeCustomerId &&
    (!remotePaymentConfig ||
      remotePaymentConfig.stripeCustomerId !==
        localPaymentInfo.stripeCustomerId)
  ) {
    await api.call(savePaymentConfigApi(localPaymentInfo))
  }
}
